export const formInlineItemGaps = [16, 26]